import {
    ComboBox,
    DefaultButton,
    Dialog,
    DialogFooter,
    DialogType,
    Dropdown,
    Label,
    PrimaryButton,
    TextField
} from "office-ui-fabric-react";
import React, { Component } from "react";
import _ from "lodash";
import { specList } from '../MetaFields/Fields/constants';
import { IContentType, IMetaBindingObject, ISpec, MetaBindingObjectTypes } from "app/services/content-type";
import { ISpecificationType } from "app/services/specification";
import { MetaTypeEnum } from "app/shared";
import { customSpecificationServices, specificationKeys } from "app/shared/constants/spec";

interface SpecModalProps {
    show: boolean;
    onSave: (data: ISpec) => void;
    onDismiss: () => void;
    isUpdateMode?: boolean;
    contentTypes?: IContentType[];
    data?: ISpec | null;
    specificationTypes?: ISpecificationType[];
}

interface MetaModalState {
    data: ISpec;
    disabledColumn?: boolean;
}

export default class SpecModal extends Component<
    SpecModalProps,
    MetaModalState
> {
    state = {
        data: { type: MetaTypeEnum.Text, column: 4 } as ISpec,
        disabledColumn: false,
    };

    UNSAFE_componentWillReceiveProps(nextProps: SpecModalProps) {
        if (nextProps.show && nextProps.show !== this.props.show) {
            this.setState({
                data: nextProps.data || { type: MetaTypeEnum.Text, column: 4 } as ISpec
            })
        }
    }

    onFieldChange(index: number, key: string, value: string) {
        const clonedItems = _.cloneDeep(this.state.data.bindings?.customOptions || []);
        clonedItems[index] = {
            ...clonedItems[index],
            [key]: value
        }
        this.setState({
            data: {
                ...this.state.data,
                bindings: {
                    ...this.state.data.bindings,
                    customOptions: clonedItems
                } as IMetaBindingObject
            }
        })
    }

    renderTypeSelector() {
        return (
            <div className="modal-form">
                <div className="item">
                    <ComboBox
                        placeholder="Spesifikasyon Tipi"
                        selectedKey={this.state.data?.name || ""}
                        label="Spesifikasyon Tipi"
                        className="custom-combobox border"
                        calloutProps={{ className: "custom-combobox-callout" }}
                        onChange={(event: any, option) => {
                            this.setState({
                                data: {
                                    ...this.state.data,
                                    name: option?.key as string,
                                    type: (option as any)?.inputType
                                },
                            });
                        }}
                        allowFreeform
                        autoComplete="on"
                        options={specificationKeys.map(item => ({ key: item.key, text: item.key, inputType: item.type }))}
                    />
                </div>
            </div>
        )
    }

    renderForm() {
        return (
            <div className="modal-form">
                <div className="item">
                    <TextField
                        placeholder="Spesifikasyon Başlığı"
                        value={this.state.data.title || ""}
                        label="Spesifikasyon Başlığı"
                        className="custom-textfield border"
                        onChange={(event: any) => {
                            this.setState({
                                data: {
                                    ...this.state.data,
                                    title: event.target.value
                                },
                            });
                        }}
                    />
                </div>
                <div className="item">
                    <Dropdown
                        placeholder="Gözükecek Sütun Sayısı (1-12)"
                        disabled={this.getColumn(this.state.data.type) as boolean}
                        label="Gözükecek Sütun Sayısı"
                        className="custom-dropdown border"
                        selectedKey={this.state.data.column}
                        calloutProps={{ className: "custom-dropdown-callout" }}
                        onChange={(_, opt) => {
                            this.setState({
                                data: {
                                    ...this.state.data,
                                    column: opt?.key as number,
                                },
                            });
                        }}
                        options={[
                            {
                                key: 1,
                                text: "1/12",
                            },
                            {
                                key: 2,
                                text: "2/12",
                            },
                            {
                                key: 3,
                                text: "3/12",
                            },
                            {
                                key: 4,
                                text: "4/12",
                            },
                            {
                                key: 5,
                                text: "5/12",
                            },
                            {
                                key: 6,
                                text: "6/12",
                            },
                            {
                                key: 7,
                                text: "7/12",
                            },
                            {
                                key: 8,
                                text: "8/12",
                            },
                            {
                                key: 9,
                                text: "9/12",
                            },
                            {
                                key: 10,
                                text: "10/12",
                            },
                            {
                                key: 11,
                                text: "11/12",
                            },
                            {
                                key: 12,
                                text: "12/12",
                            },
                        ]}
                    />
                </div>
            </div>
        );
    }

    getColumn(type: MetaTypeEnum): number | boolean {
        const meta = specList.find(x => x.type === type);
        if (meta?.column) {
            return meta.column;
        }
        return false;
    }

    renderSpecList() {
        return (
            <div className="meta-constant-list row">
                {specList.map((item, index) => (
                    <div style={{ pointerEvents: "none" }} key={index} className="meta-item large">
                        <div
                            className={
                                item.type === this.state.data.type
                                    ? "meta-item-wrapper row active"
                                    : "meta-item-wrapper row"
                            }
                        // onClick={() => {
                        //     this.setState({
                        //         data: {
                        //             ...this.state.data,
                        //             type: item.type,
                        //             default: null,
                        //             column: this.getColumn(item.type) as number || 4
                        //         }
                        //     });
                        // }}
                        >
                            <div className="icon">
                                <div className="default">
                                    <i className={`${item.icon}`}></i>
                                </div>
                                <div className="checkmark">
                                    <i className="icon-checkmark"></i>
                                </div>
                            </div>
                            <div className="text">
                                {item.title}
                                <div className="sub-text">
                                    {item.type === this.state.data.type
                                        ? "Seçildi"
                                        : "Seçmek için tıkla"}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    renderDropdownWithCustomOptions() {
        const items = [...(this.state.data.bindings?.customOptions || []), { key: "", text: "" }];
        return (
            <div className="meta-dropdown-values">
                {items.map((item, index) => (
                    <div className="meta-dropdown-value row">
                        <TextField
                            className="custom-textfield col"
                            label="Öğe Değeri"
                            placeholder="ÖR: deger1"
                            value={item.key as string}
                            onChange={(event: any) => this.onFieldChange(index, "key", event.target.value)}
                        />
                        <TextField
                            className="custom-textfield col"
                            label="Öğe Başlığı"
                            placeholder="ÖR: Değer 1"
                            value={item.text as string}
                            onChange={(event: any) => this.onFieldChange(index, "text", event.target.value)}
                        />
                        <i
                            onClick={() => {
                                const clonedItems = _.cloneDeep(this.state.data.bindings?.customOptions || []);
                                clonedItems.splice(index, 1);
                                this.setState({
                                    data: {
                                        ...this.state.data,
                                        bindings: {
                                            ...this.state.data.bindings,
                                            customOptions: clonedItems
                                        } as IMetaBindingObject
                                    }
                                })
                            }}
                            className={(index + 1) === items.length ? "icon-close passive" : "icon-close1"}
                        />

                    </div>
                ))}
            </div>
        )
    }

    renderDropdownWithSpecificationItems() {
        return (
            <Dropdown
                options={(this.props.specificationTypes || []).map(item => ({ type: item.key as string, key: item.id as string, text: item.title }))}
                className="custom-dropdown"
                calloutProps={{ className: "custom-dropdown-callout" }}
                label="Eşlenecek Spesifikasyon Seçiniz"
                onChange={(_, opt) => {
                    this.setState({
                        data: {
                            ...this.state.data,
                            bindings: {
                                ...this.state.data.bindings,
                                specificationType: (opt as any)?.type as string,
                                specificationTypeId: opt?.key as string
                            } as IMetaBindingObject
                        }
                    })
                }}
                selectedKey={this.state.data?.bindings?.specificationTypeId}
            />
        )
    }

    renderDropdownWithCustomService() {
        return (
            <Dropdown
                options={(customSpecificationServices || []).map(item => {
                    return { key: item.name as string, text: item.title }
                })}
                className="custom-dropdown"
                calloutProps={{ className: "custom-dropdown-callout" }}
                label="Eşlenecek Özel Servis Seçiniz"
                onChange={(_, opt) => {
                    this.setState({
                        data: {
                            ...this.state.data,
                            bindings: {
                                ...this.state.data.bindings,
                                endpointName: opt?.key as string
                            } as IMetaBindingObject
                        }
                    })
                }}
                selectedKey={this.state.data?.bindings?.endpointName}
            />
        )
    }

    renderDropdownWithContentType() {
        return (
            <Dropdown
                options={(this.props.contentTypes || []).map(item => ({ key: item.id as string, text: item.title }))}
                className="custom-dropdown"
                calloutProps={{ className: "custom-dropdown-callout" }}
                label="Eşlenecek İçerik Tipi Seçiniz"
                onChange={(_, opt) => {
                    this.setState({
                        data: {
                            ...this.state.data,
                            bindings: {
                                ...this.state.data.bindings,
                                contentTypeId: opt?.key as string
                            } as IMetaBindingObject
                        }
                    })
                }}
                selectedKey={this.state.data?.bindings?.contentTypeId}
            />
        )
    }


    renderFillOptions() {
        if (this.state.data?.type !== MetaTypeEnum.Dropdown && this.state.data?.type !== MetaTypeEnum.ComboBox && this.state.data?.type !== MetaTypeEnum.Contributor) return null;
        return (
            <React.Fragment>
                <Dropdown
                    options={[
                        {
                            key: "",
                            text: "Seçilmedi"
                        },
                        {
                            key: MetaBindingObjectTypes.ContentType,
                            text: "İçerik Tiplerinden Doldur"
                        },
                        {
                            key: MetaBindingObjectTypes.Specification,
                            text: "Spesifikasyonlardan Doldur"
                        },
                        {
                            key: MetaBindingObjectTypes.CustomService,
                            text: "Özel Servisten Doldur"
                        },
                        {
                            key: MetaBindingObjectTypes.Custom,
                            text: "Özel Olarak Doldur"
                        }]}
                    className="custom-dropdown"
                    calloutProps={{ className: "custom-dropdown-callout" }}
                    label="Doldurma Tipi"
                    selectedKey={this.state.data?.bindings?.type || ""}
                    onChange={(_, opt) => {
                        this.setState({
                            data: {
                                ...this.state.data,
                                bindings: {
                                    ...this.state.data.bindings,
                                    type: opt?.key as MetaBindingObjectTypes,
                                    contentTypeId: "",
                                    specificationTypeId: "",
                                    endpointName: ""
                                }
                            }
                        })
                    }}
                />
                {this.state.data?.bindings?.type === MetaBindingObjectTypes.ContentType && (
                    this.renderDropdownWithContentType()
                )}
                {this.state.data?.bindings?.type === MetaBindingObjectTypes.Specification && (
                    this.renderDropdownWithSpecificationItems()
                )}
                {this.state.data?.bindings?.type === MetaBindingObjectTypes.CustomService && (
                    this.renderDropdownWithCustomService()
                )}
                {this.state.data?.bindings?.type === MetaBindingObjectTypes.Custom && (
                    this.renderDropdownWithCustomOptions()
                )}
            </React.Fragment>
        )
    }

    render() {
        if (!this.props.show) return null;
        return (
            <Dialog
                hidden={!this.props.show}
                onDismiss={() => this.props.onDismiss()}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: this.props.isUpdateMode ? "Spesifikasyon Düzenle" : "Yeni Spesifikasyon Ekle",
                    closeButtonAriaLabel: "Kapat",
                    subText:
                        "Geçerli içerik tipine sahip içeriklerde kullanılmak üzere, belirlediğiniz tipte ve isimde bir spesifikasyon (özel alan) ekleyin!",
                }}
                modalProps={{
                    className: "confirm",
                    isBlocking: false,
                    styles: { main: { width: "1000px !important", minWidth: "1000px !important" } },
                }}
            >
                <div style={{ overflow: "hidden" }} className="meta-scrollable">
                    {this.renderTypeSelector()}
                    <Label style={{ marginTop: "2.5px" }}>Görünüm Tipi (Spesifikasyon tipine göre belirlenir)</Label>
                    {this.renderSpecList()}
                    {this.renderForm()}
                    {this.renderFillOptions()}
                    {/* {this.renderCheckboxes()} */}
                    {/* {this.renderMetaDefaults()} */}
                </div>
                <DialogFooter>
                    <DefaultButton
                        onClick={() =>
                            this.setState(
                                { data: { type: MetaTypeEnum.Text, column: 4 } as ISpec },
                                () => this.props.onDismiss()
                            )
                        }
                        text="İptal"
                    />
                    <PrimaryButton
                        onClick={() => {
                            this.props.onSave(this.state.data);
                            this.setState({
                                data: { type: MetaTypeEnum.Text, column: 4 } as ISpec,
                            });
                        }}
                        text={this.props.isUpdateMode ? "Güncelle" : "Ekle"}
                        disabled={
                            !this.state.data.title || !this.state.data.name ? true : false
                        }
                    />
                </DialogFooter>
            </Dialog>
        );
    }
}
